import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RoleHomeRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const roleId = localStorage.getItem('RoleID');
    let target = '/home';

    if (roleId == '4') {
      target = '/Pagehome';
    } else if (roleId && roleId != '1' && roleId != '4') {
      target = '/adminhome';
    }

    navigate(target, { replace: true });
  }, [navigate]);

  return null;
};

export default RoleHomeRedirect;


